// src\themes\lino\elements\Header\HeaderNavMenu.tsx
import { getMainMenu } from "@/core/lib/api/main/menu-api";
import { MenuItem } from "@/core/types/menuApi";
import HeaderMegaMenu from "./HeaderMegaMenu";

export default async function HeaderNavMenu() {
  const mainMenu: MenuItem[] = await getMainMenu();

  return <HeaderMegaMenu items={mainMenu} />;
}
